const getUserAgent = (): string => window.navigator.userAgent;

export { getUserAgent };
